<template>
	<div>
		<div id="panel-4" class="panel">
			<div class="panel-hdr ">
				<h2>
					{{ __t('LIST') }} <span class="fw-300"><i>{{__t('RESTAURANTS')}}</i></span>
				</h2>

				<div class="panel-toolbar">
                    <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
                        <i class="fal fa-plus"></i>
                    </button>

					<button class="btn btn-panel waves-effect waves-themed"
							data-action="panel-fullscreen"
							data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
					</button>
				</div>
			</div>

			<div class="panel-container show">
				<div class="panel-content">
					<div class="filter_block mb-3">
						<filter_restaurants></filter_restaurants>
					</div>

					<b-skeleton-table
						v-if="is_load"
						:rows=this.cur_records
                        :columns="2"
                        :hide-header=true
                        :table-props="{ bordered: false, striped: true }"
					>
					</b-skeleton-table>

					<div class="inbox_vue_list" v-if="!is_load">

						<div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="up"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
						</div>

						<b-table
							v-if="rows.length > 0"
							:tbody-tr-class="rowClass"
							striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

							<!-- header fields -->
							<template v-slot:head(id)="data">
								<div class="status_info" style="max-width: 50px">
									{{ __t('STATUS') }}
								</div>
							</template>

							<template v-slot:head(ordering)="data">

                                <grid_list
                                    :list_ordering="'ordering'"
                                    :field_name="__t('ORDERING')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
							</template>

							<template v-slot:head(uniq_id)="data">
                                <grid_list
                                    :list_ordering="'uniq_id'"
                                    :field_name="__t('UNIQ_ID')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
							</template>

							<template v-slot:head(title)="data">
                                <grid_list
                                    :list_ordering="'title'"
                                    :field_name="__t('TITLE')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
							</template>

							<template v-slot:head(added)="data">
								{{__t('DATE')}}
							</template>



							<!-- body draw -->
							<template  v-slot:cell(id)="data">
								<div class="custom-control custom-checkbox">
									<input
										:disabled="true"
										:name="'cid[]'"
										v-model="data.item.published"
										type="checkbox"
										class="custom-control-input"
										:id="data.item.id + '_cust_id'" />
									<label class="custom-control-label cursor-pointer bolder" :for="data.item.id + '_cust_id'"></label>
								</div>
							</template>

							<template v-slot:cell(ordering)="data">
								<div class="btn btn-primary btn-icon rounded-circle position-relative js-waves-off">
									<i class="fal fa-sort"></i>
									<span class="badge border border-light rounded-pill bg-danger-500 position-absolute pos-top pos-right">
									{{data.item.ordering}}
								</span>
								</div>
							</template>


							<template v-slot:cell(uniq_id)="data">
								<div class="">
									<div class="d-flex flex-start w-100 fs-xl mb-2" >
										<div  class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer" v-on:click="open_item(data.item)">
											<i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
											<i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
										</div>
										{{data.item.uniq_id}}
									</div>

									<div class="d-flex flex-start w-100">
										<div class="small badge border border-success">
											{{data.item.provider}}
										</div>
										<div class="ml-3 small badge border border-info" v-if="obj_to_null(data.item.city)">
											{{data.item.city.title}}
										</div>
                                        <div class="ml-3 small badge border border-warning" v-if="data.item.hasOwnProperty('real_org')">
                                            {{data.item.real_org}}
                                        </div>


									</div>
								</div>
							</template>

							<template v-slot:cell(title)="data">
								<div class="prod_name  fs-xl color-success-600">
									<span v-html=nice_search(data.item.title)></span>
								</div>
								<div class="categ_name">
									<div class="small badge border border-primary text-primary" v-if="obj_to_null(data.item.address)">
										{{data.item.address}}
									</div>
								</div>
							</template>
						</b-table>


						<div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="down"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
						</div>

					</div>


				</div>
			</div>

		</div>

		<resturant_modal></resturant_modal>

	</div>
</template>

<script>

import {mapGetters} from "vuex";



import Filter_restaurants from "./filter_restaurant";
import Grid_list from "../../sys/list/grid_list.vue";
import Pagination_list from "../../sys/list/pagination_list.vue";


import Resturant_modal from "./item/resturant_modal.vue";

export default {
	name: "restaurants",
	components : {
        Grid_list,
        Pagination_list,
		Resturant_modal,
		Filter_restaurants,
	},
    data() {
        return {
            rows: [],
            is_load: true,
            is_check_all: false,
            cur_records: 35,
            component_type: "restaurants",
            grid_trigger: "restaurant_inbox_change_state",

            list: {
                ordering: "ordering",
                direction: "DESC",
                start: 0,
                limit: 30
            },

            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },

            filter: {
                search: "",
                provider_id: "",
                city_id: "",
                rest_group: ""
            },

            fields: [
                { key: 'id', label: '', class: 'text-center' },
                { key: 'ordering', label: '<i class="fas fa-sort"></i>', class: 'text-center hidden-md-down' },
                { key: 'uniq_id', label: '<i class="fal fa-cog width-2"></i>', class: '' },
                { key: 'title', label: 'r.title', class: '' },
                { key: 'added', label: 'r.added', class: '' },
            ]
        }
    },

	mounted() {
        this.load_items();
	},

	created() {
		EventBus.$on("search_rest_called",this.search_work);
        EventBus.$on("clean_rest_filter",this.clean_inbox_filter);

        EventBus.$on("org_filter_changed",this.filter_select);



		EventBus.$on("products_reload_items",this.load_items);
		EventBus.$on(this.grid_trigger,this.change_state)

		EventBus.$on("reload_restaurants",this.load_items);

	},

	methods : {

        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },

        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },

        search_work(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },

        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },

        clean_inbox_filter() {

            this.filter = {
                search: "",
                provider_id: "",
                city_id: "",
                rest_group: ""
            };

            this.list = {
                ordering: "ordering",
                direction: "DESC",
                start: 0,
                limit: 30
            };

            this.load_items();
        },

        async load_items() {
            this.rows = [];
            this.is_load = true;

            await api.post('/internal/v1/catalog/restaurants', {
                filter  : this.filter,
                list    : this.list
            })
            .then(({ data }) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.rows = data.data;

                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }
            })
            .catch(({ response }) => {
                this.is_load = false;
                this.rows = [];
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },


		rowClass(item) {
			if (!item) return;
			return item.class;
		},

		open_item (item) {
			EventBus.$emit("restaurant_edit",parseInt(item.id));
		},

        create() {
            EventBus.$emit("restaurant_edit",0);
        },

		nice_search(str) {
			if (!this.filter.hasOwnProperty('search')) {
				return str;
			}
			return str.replace(new RegExp(this.filter.search, "i"), match => {
				return '<span class="text-danger">' + match + '</span>';
			});

		},
	},
	computed: {

		...mapGetters({
			'user' : "user/getUser",
		}),
	}
}
</script>

<style scoped>
.table thead th:first-child {
	max-width: 20px;
}
</style>
